import React from "react";
import PropTypes from "prop-types";

class Checkbox extends React.Component {
    constructor(props) {
        super(props);

        const {
            checked = false
        } = this.props;

        this.state = {
            checked
        };

        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { checked } = nextProps;

        if (checked !== this.state.checked) {
            this.setState({ checked });
        }
    }

    onChange() {
        const { onChange = null, value, name } = this.props;

        if (onChange) {
            onChange({ name, checked: !this.state.checked, value });
        }

        this.setState({ checked: !this.state.checked });
    }

    render() {
        const {
            className = "",
            name = "",
            id = "",
            value = "",
            children
        } = this.props;

        const { checked } = this.state;

        const label = children ? <div className="checkbox__box-label"> { children } </div> : null;

        return (
            <div className={ `checkbox ${ className }` }>
                <input
                    type="checkbox"
                    id={ id }
                    name={ name }
                    value={ value }
                    checked={ checked }
                    onChange={ this.onChange }
                    aria-label={ id }
                />
                <button aria-label={ name } className="checkbox__box" type="button" onClick={ this.onChange } />
                { label }
            </div>
        );
    }
}

Checkbox.propTypes = {
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    value: PropTypes.string
};

export default Checkbox;
